module.exports = __webpack_public_path__ + "static/heylikey-bf92328f4901aa7f63dbe8f4732a7325.png";